const AdminDashboard = () => {
    return <h1>Welcome to Admin Dashboard</h1>;
};

export default AdminDashboard;
